import { createFileRoute } from '@tanstack/react-router'

import { GuaranteesPageSkeleton } from '#/modules/guarantee/front-office/guarantees-page/guarantees-page-skeleton.tsx'
import { GuaranteesPage } from '#/modules/guarantee/front-office/guarantees-page/guarantees-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'

export const Route = createFileRoute('/(customer)/_shell/contract-guarantees-v2/')({
  loader: async ({ context }) => {
    const { queryClient, trpc } = context
    void queryClient.prefetchQuery(
      trpc.invoices.hasUnpaidInvoices.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
    )
    await queryClient.ensureQueryData(
      trpc.contracts.listMyContracts.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
    )
  },
  pendingComponent: GuaranteesPageSkeleton,
  pendingMs: 150,
  component: GuaranteesPage,
})
